// extracted by mini-css-extract-plugin
module.exports = {"root":"WorkshopsPage-module--root--1UxwL","text":"WorkshopsPage-module--text--sbRkq","workshops":"WorkshopsPage-module--workshops--ZIRmr"};